import { useEffect, useState } from "react";
import { LifeBuoy, Phone } from "lucide-react";
import { onCrisis } from "../lib/safety";

/**
 * KLA-016. A global crisis-support overlay. When any Klair surface detects
 * self-harm or suicidal-ideation content (client net) or the server flags
 * distress, this pauses the screen and shows support resources prominently.
 * Mounted once at the app root. Copy and helpline numbers must be kept current
 * and signed off by a qualified clinical / compliance authority.
 */
const callStyle = {
  display: "flex", alignItems: "center", gap: "0.55rem", textDecoration: "none",
  color: "#1A202C", background: "#FDECEC", border: "1px solid #F5C2C0",
  borderRadius: "0.6rem", padding: "0.7rem 0.9rem", fontSize: "0.98rem",
};

export default function CrisisOverlay() {
  const [open, setOpen] = useState(false);
  useEffect(() => onCrisis(() => setOpen(true)), []);
  if (!open) return null;
  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-label="Support resources"
      data-testid="crisis-overlay"
      style={{ position: "fixed", inset: 0, zIndex: 2147483647, background: "rgba(24,0,0,0.72)", display: "flex", alignItems: "center", justifyContent: "center", padding: "1.5rem", fontFamily: "system-ui, -apple-system, sans-serif" }}
    >
      <div style={{ maxWidth: "30rem", width: "100%", background: "#fff", borderTop: "8px solid #D32029", borderRadius: "0.9rem", boxShadow: "0 20px 60px rgba(0,0,0,0.45)", overflow: "hidden" }}>
        <div style={{ background: "#D32029", color: "#fff", padding: "0.85rem 1.25rem", display: "flex", alignItems: "center", gap: "0.6rem", fontWeight: 700, lineHeight: 1.3 }}>
          <LifeBuoy size={20} aria-hidden="true" /> You are not alone. Help is available right now.
        </div>
        <div style={{ padding: "1.25rem 1.4rem", color: "#1A202C", lineHeight: 1.55 }}>
          <p style={{ margin: "0 0 1rem" }}>
            It sounds like you are carrying something really heavy. You deserve support, and people are ready to listen, any time of day.
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem", margin: "0 0 1.1rem" }}>
            <a href="tel:14416" style={callStyle}><Phone size={16} aria-hidden="true" /> Tele-MANAS (India): <b>&nbsp;14416</b>&nbsp; or 1-800-891-4416</a>
            <a href="tel:18005990019" style={callStyle}><Phone size={16} aria-hidden="true" /> KIRAN Helpline (India): <b>&nbsp;1800-599-0019</b></a>
          </div>
          <p style={{ margin: "0 0 1.1rem", fontSize: "0.9rem", color: "#5b6470" }}>
            If you are in immediate danger, please call your local emergency number now.
          </p>
          <button
            type="button"
            onClick={() => setOpen(false)}
            data-testid="crisis-overlay-close"
            style={{ width: "100%", padding: "0.72rem", borderRadius: "0.6rem", border: "none", background: "#1A202C", color: "#fff", fontWeight: 600, cursor: "pointer" }}
          >
            I understand, close this
          </button>
        </div>
      </div>
    </div>
  );
}
